package io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.`simple-icons`.Icons

public val Icons.YoutubeSimpleIcons: ImageVector
    get() {
        if (_youtubeSimpleIcons != null) {
            return _youtubeSimpleIcons!!
        }
        _youtubeSimpleIcons = Builder(name = "YoutubeSimpleIcons", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 24.0f, viewportHeight = 24.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(23.50f, 6.19f)
                arcToRelative(3.02f, 3.02f, 0.0f, false, false, -2.12f, -2.14f)
                curveTo(19.51f, 3.55f, 12.0f, 3.55f, 12.0f, 3.55f)
                reflectiveCurveToRelative(-7.51f, 0.0f, -9.38f, 0.51f)
                arcTo(3.02f, 3.02f, 0.0f, false, false, 0.50f, 6.19f)
                curveTo(0.0f, 8.07f, 0.0f, 12.0f, 0.0f, 12.0f)
                reflectiveCurveToRelative(0.0f, 3.93f, 0.50f, 5.81f)
                arcToRelative(3.02f, 3.02f, 0.0f, false, false, 2.12f, 2.14f)
                curveToRelative(1.87f, 0.51f, 9.38f, 0.51f, 9.38f, 0.51f)
                reflectiveCurveToRelative(7.51f, 0.0f, 9.38f, -0.51f)
                arcToRelative(3.02f, 3.02f, 0.0f, false, false, 2.12f, -2.14f)
                curveTo(24.0f, 15.93f, 24.0f, 12.0f, 24.0f, 12.0f)
                reflectiveCurveToRelative(0.0f, -3.93f, -0.50f, -5.81f)
                close()
                moveTo(9.55f, 15.57f)
                verticalLineTo(8.43f)
                lineTo(15.82f, 12.0f)
                lineToRelative(-6.27f, 3.57f)
                close()
            }
        }
        .build()
        return _youtubeSimpleIcons!!
    }

private var _youtubeSimpleIcons: ImageVector? = null
